import { AfterViewInit, Component, EventEmitter, Inject, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClImageUploadTableComponent } from '../cl-image-upload-table/cl-image-upload-table.component';
import { WfSignature, WfSignatureResource } from 'src/app/components/workflow/workflow';
import { Checklist, ChecklistTemplate } from 'src/app/components/checklists/checklists';
import { utils } from 'src/app/modules/libs/utils';
import { ClImageUploadContentComponent, RadTableConfiguration } from '../cl-image-upload-content/cl-image-upload-content.component';
import { BaseComponent } from 'src/app/common/base/base.component';

type DialogRectState = {
  width: string;
  height: string;
  top: string;
  left: string;
};

@Component({
  selector: 'app-image-table-popup',
  templateUrl: './image-table-popup.component.html'
})
export class ImageTablePopupComponent extends BaseComponent implements AfterViewInit, OnInit {

  @Output() saveConfiguration = new EventEmitter<RadTableConfiguration>();

  context!: CanvasRenderingContext2D;

  maximized = false;
  panelOpen = 2;
  saving?: boolean;

  title?: string;
  disabled?: boolean;
  signature?: WfSignature;
  taskID?: number;
  checklist?: Checklist;
  number?: string;
  date?: Date;
  roleIds?: number[];
  checklistTemplate?: ChecklistTemplate;
  configuration?: RadTableConfiguration;
  enableColumnsBuilder?: boolean;

  editor?: boolean;
  builder?: boolean;

  private previousState: DialogRectState | null = null;

  panel = RadTablePanel;

  @ViewChild(ClImageUploadContentComponent) imageUploadContent?: ClImageUploadContentComponent;

  constructor(
    protected override injector: Injector,
    public dialogRef: MatDialogRef<ImageTablePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(injector);
    this.title = data.title;
    this.disabled = data.disabled;
    this.signature = data.signature;
    this.taskID = data.taskID;
    this.date = data.date;
    this.checklist = data.checklist;
    this.number = data.number;
    this.roleIds = data.roleIds;
    this.checklistTemplate = data.checklistTemplate;
    this.configuration = data.configuration;
    this.enableColumnsBuilder = data.enableColumnsBuilder;
    this.builder = data.builder;
    this.editor = data.editor;

  }

  ngOnInit(): void {
    this.setFormDirty(false);
  }

  ngAfterViewInit(): void {
    const pane = this.getOverlayPane();
    if (pane) {
      pane.classList.add('window-dialog-pane-ready');
    }
  }

  // close(): void {
  //   this.dialogRef.close();
  // }

  changed(e: RadTableConfiguration) {
    this.configuration = e;
    this.setFormDirty();
  }

  async close() {
    if (await this.canDeactivate()) {
      this.dialogRef.close();
    }
  }

  save() {
    this.saveConfiguration.emit(this.configuration);
    this.setFormDirty(false);
  }


  toggleMaximize(): void {
    const pane = this.getOverlayPane();
    if (!pane) return;

    if (!this.maximized) {
      this.previousState = {
        width: pane.style.width || '900px',
        height: pane.style.height || '600px',
        top: pane.style.top || '',
        left: pane.style.left || ''
      };

      this.maximized = true;
      pane.classList.add('window-dialog-maximized');

      this.dialogRef.updateSize('100vw', '100vh');
      this.dialogRef.updatePosition({ top: '0', left: '0' });
    } else {
      this.maximized = false;
      pane.classList.remove('window-dialog-maximized');

      this.dialogRef.updateSize(
        this.previousState?.width || '900px',
        this.previousState?.height || '600px'
      );

      if (this.previousState?.top || this.previousState?.left) {
        this.dialogRef.updatePosition({
          top: this.previousState?.top || '',
          left: this.previousState?.left || ''
        });
      } else {
        this.dialogRef.updatePosition();
      }
    }
  }

  private getOverlayPane(): HTMLElement | null {
    const containerEl = this.dialogRef.componentInstance
      ? document.querySelector('.cdk-overlay-pane.window-dialog')
      : null;

    return containerEl as HTMLElement | null;
  }

  async selectPanel(panel: RadTablePanel) {
    if (await this.canDeactivate()) {
      this.panelOpen = panel;
      this.imageUploadContent!.showImageOptions = panel == RadTablePanel.Image;
    }
  }

}

export enum RadTablePanel {
  None = 0,
  Image = 1,
  Table = 2,
  History = 3
}

